import { createRouter, createWebHashHistory } from 'vue-router'
import { isLoggedIn } from '@/utils/auth'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: { public: true, title: '登录' }
  },
  {
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    redirect: '/overview',
    children: [
      {
        path: 'overview',
        name: 'overview',
        component: () => import('@/views/Overview.vue'),
        meta: { title: '平台概览' }
      },
      {
        path: 'tenants',
        name: 'tenants',
        component: () => import('@/views/TenantList.vue'),
        meta: { title: '商家管理' }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/overview'
  }
]

const router = createRouter({
  // 用 hash 模式：部署时不需要服务端配置 history fallback
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to) => {
  const logged = isLoggedIn()

  if (!to.meta.public && !logged) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }

  // 已登录时访问登录页，直接进首页
  if (to.name === 'login' && logged) {
    return { name: 'overview' }
  }

  return true
})

router.afterEach((to) => {
  const title = to.meta.title
  document.title = title ? `${title} · 商城后台` : '商城后台'
})

export default router
